<template>
    <section class="bg-[#250871] text-white py-16 px-4">
      <div class="max-w-6xl mx-auto text-center">
        <h2 class="text-3xl sm:text-4xl font-bold mb-12">Nossos Data Centers</h2>
  
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            v-for="(dc, index) in dataCenters"
            :key="index"
            class="bg-white text-gray-800 rounded-2xl overflow-hidden shadow-md flex flex-col"
          >
            <img :src="dc.img" :alt="dc.nome" class="w-full h-48 object-cover" />
  
            <div class=" flex flex-col justify-between flex-grow text-center p-16">
              <h3 class="text-lg font-bold mb-2">{{ dc.nome }}</h3>
              <p class="font-semibold">Localização:</p>
              <p class="text-gray-500 mb-2">{{ dc.local }}</p>
  
              <p class="font-semibold">Ping:</p>
              <p class="text-[#250871] font-semibold mb-4">{{ dc.ping }}</p>
  
              <button class="bg-[#f94368] text-white px-6 py-2 rounded-full font-bold text-sm hover:bg-pink-600 transition">
                {{ dc.velocidade }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const dataCenters = [
    {
      nome: 'Canadá Data Center',
      local: 'Montreal',
      ping: 'ping 160ms',
      velocidade: '50 Gbps',
      img: '/datacenter/data1.png'
    },
    {
      nome: 'USA Data Center I',
      local: 'Dallas',
      ping: 'ping 140ms',
      velocidade: '50 Gbps',
      img: '/datacenter/data2.png'
    },
    {
      nome: 'USA Data Center II',
      local: 'Atlanta',
      ping: 'ping 140ms',
      velocidade: '50 Gbps',
      img: '/datacenter/data3.png'
    }
  ]
  </script>
  
  <style scoped>
  </style>
  